export default "__VITE_ASSET__BU1XRC7z__"